/** @format */

const tms = {
    // Pictos and icons
    tms_create_campain_flag_circled: "/assets/images/svg/tms/tms_create_campain_flag_circled.svg",
    tms_create_campain_flag_only: "/assets/images/svg/tms/tms_create_campain_flag_only.svg",
    tms_create_campain_rocket_circled: "/assets/images/svg/tms/tms_create_campain_rocket_circled.svg",
    tms_create_campain_rocket_only: "/assets/images/svg/tms/tms_create_campain_rocket_only.svg",
    tms_ending_campain_creation_congrats: "/assets/images/svg/tms/tms_ending_campain_creation_congrats.svg",
    tms_first_time_rocket: "/assets/images/svg/tms/tms_first_time_rocket.png",
    tms_tab_activation_pending_rocket: "/assets/images/svg/tms/tms_tab_activation_pending_rocket.svg",
    tms_tab_activation_success_rocket: "/assets/images/svg/tms/tms_tab_activation_success_rocket.svg",
    tms_tab_parametre_type_de_campagne: "/assets/images/svg/tms/tms_tab_parametre_type_de_campagne.svg",
    tms_tab_projet_forumlaire_candidature: "/assets/images/svg/tms/tms_tab_projet_forumlaire_candidature.svg",
    // Create a campaign
    tms_create_campaign_express: "/assets/images/svg/tms/tms_express.svg",
    tms_create_campaign_step: "/assets/images/svg/tms/tms_par_etape.svg",
}

export default tms
